<template>
  <BaseFetchData :action="fetchFunnelStages" v-slot="fetchDataProps">
    <BaseCard v-if="fetchDataProps.status.resolved">
      <BaseCardBody>
        <div>
          <h3 class="text-lg leading-6 font-medium text-gray-900">Funnel stages</h3>
          <p class="max-w-2xl text-sm text-gray-500">The funnel's stages</p>
        </div>
        <div class="mt-6 space-y-8">
          <FunnelStageList v-model="funnelStages" :funnel-id="funnel.id">
            <template #funnel-stage="funnelStageListProps">
              <FunnelStageItem
                :funnel-stage="funnelStageListProps.funnelStage"
                :disabled="funnelStageListProps.reordering"
                @deleted="fetchFunnelStages"
                @updated="fetchFunnelStages"
              />
            </template>

            <template #empty-state>
              <h3 class="mt-2 text-sm font-medium text-gray-900">No funnel stages</h3>
              <p class="mt-1 text-sm text-gray-500">Get started by creating a new stage.</p>
              <div class="mt-6">
                <FunnelStageAddAction :funnel="funnel" @created="handleOnCreated" />
              </div>
            </template>
          </FunnelStageList>
        </div>
      </BaseCardBody>
      <BaseCardFooter v-if="funnelStages.length" gray>
        <FunnelStageAddAction :funnel="funnel" @created="handleOnCreated" />
      </BaseCardFooter>
    </BaseCard>
  </BaseFetchData>
</template>

<script>
import { funnelStagesClient } from '@/api/clients';
import FunnelStageAddAction from './FunnelStageAddAction.vue';
import FunnelStageItem from './FunnelStageItem.vue';
import FunnelStageList from './FunnelStageList.vue';

export default {
  components: {
    FunnelStageAddAction,
    FunnelStageItem,
    FunnelStageList,
  },
  props: {
    funnel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      funnelStages: [],
    };
  },
  methods: {
    setFunnelStages(funnelStages) {
      this.funnelStages = funnelStages;
    },
    async fetchFunnelStages() {
      try {
        const response = await funnelStagesClient.list(this.funnel.id, {
          include: ['audiences'],
        });

        this.setFunnelStages(response.data);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    handleOnCreated() {
      this.fetchFunnelStages();
    },
    async handleOnChange() {
      //
    },
  },
};
</script>
